"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const apollo_link_ws_1 = require("@8base/apollo-link-ws");
const utils_1 = require("./utils");
/**
 * Subscription Link
 * @param {SubscriptionLinkParameters} options - The subscription link options.
 * @param {Function} options.uri - The uri which used for WebSocket connection.
 * @param {Function} [options.onAuthError] - The callback which called when attempt to refresh authentication is failed.
 * @param {Function} [options.onIdTokenExpired] - The callback which called when id token is expired.
 */
class SubscriptionLink extends apollo_link_ws_1.WebSocketLink {
    constructor({ uri, getAuthState, onIdTokenExpired, onAuthError }) {
        super({
            uri,
            options: {
                connectionParams: () => this.getConnectionsParams(),
                connectionCallback: (payload) => this.connectionCallback(payload),
                reconnect: true,
                reconnectionAttempts: 5,
                lazy: true,
            },
            // tslint:disable-next-line
            webSocketImpl: class WebSocketWithoutProtocol extends WebSocket {
                constructor(url) {
                    super(url); // ignore protocol
                }
            },
        });
        this.expired = false;
        this.getAuthState = getAuthState;
        this.onAuthError = onAuthError;
        this.onIdTokenExpired = onIdTokenExpired;
    }
    handleTokenExpired() {
        if (typeof this.onIdTokenExpired === 'function') {
            return this.onIdTokenExpired();
        }
        return Promise.reject();
    }
    handleAuthFailed(err) {
        if (typeof this.onAuthError === 'function') {
            this.onAuthError(err);
        }
    }
    getConnectionsParams() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.expired) {
                yield this.handleTokenExpired();
                this.expired = false;
            }
            const authState = this.getAuthState();
            return authState;
        });
    }
    connectionCallback(payload = {}) {
        if (utils_1.isIdTokenExpiredError(payload)) {
            this.expired = true;
        }
        else if (utils_1.isRefreshTokenExpiredError(payload)) {
            this.handleAuthFailed();
        }
    }
}
exports.SubscriptionLink = SubscriptionLink;
//# sourceMappingURL=SubscriptionLink.js.map